import { Injectable } from '@angular/core';

import {DimensionLevelService} from './dimension-level.service';
import {DimensionItem, DimensionLevel, Perspective} from '@selpia/shared/models';

@Injectable()
export class AlwaysTopDimensionLevelService extends DimensionLevelService {
  getDimensionLevel(dimensionItem: DimensionItem, perspective: Perspective | undefined): DimensionLevel | undefined {
    console.log('AlwaysTopDimensionLevelService', perspective?.focusDimensionLevel, dimensionItem.dimensionLevelName);

    const dimension = dimensionItem.dimension;
    const dimensionLevel = dimensionItem.dimensionLevel;
    const perspectiveDimensionLevel = perspective?.focusDimensionLevel;
    const sameDimensionAsPerspective =
      !!perspectiveDimensionLevel && dimension.levels.includes(perspectiveDimensionLevel);

    if (sameDimensionAsPerspective) {
      console.log('AlwaysTopDimensionLevelService dimensionLevel', dimensionLevel);
      return dimensionLevel;
    }
    console.log('AlwaysTopDimensionLevelService perspectiveDimensionLevel', perspectiveDimensionLevel);
    return perspectiveDimensionLevel;
  }
}
